module.exports = __webpack_public_path__ + "img/mollie.4eb1771b.png";